import { render, staticRenderFns } from "./MyprofileFreespaceCard.vue?vue&type=template&id=ab757f76"
import script from "./MyprofileFreespaceCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyprofileFreespaceCard.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports